import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Box, Card, ButtonLink } from './core';
import { NetworkPrompt } from './NetworkPrompt';
import { useChain, useCorrectNetwork, useAdmin } from '@sc1/common';
import { getVaultPath } from '../utils';

export const RequireAdmin = ({
  children,
}: {
  children: any;
}): JSX.Element | null => {
  const { vaultAddress, vaultType } = useParams();
  const { search } = useLocation();
  const chain = useChain();

  const isCorrectNetwork = useCorrectNetwork(chain);

  const { isAdmin } = useAdmin();

  if (!isCorrectNetwork) return <NetworkPrompt chain={chain} />;
  if (!isAdmin) {
    return (
      <Card
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ my: 3 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ my: 3 }}>
              You do not have permission to view this tab
            </Box>
            <Box>
              <ButtonLink
                to={{
                  pathname: getVaultPath(vaultAddress, vaultType),
                  search,
                }}
              >
                Switch to Public View
              </ButtonLink>
            </Box>
          </Box>
        </Box>
      </Card>
    );
  }
  return children;
};
